import { ErrorDescription } from '../apiResult/interfaces';
import { notify } from './notify';

export const showErrorNotification = (error: ErrorDescription | null) => {
    notify({
        type: 'danger',
        message: error!.message,
    });
};
